import HomeD5 from "./HomeD5";

export default HomeD5;